var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKionMusicIconGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9067 71.0195C53.9063 59.857 45.4475 51.1814 34.2537 51.1813C23.0647 51.1813 14.5994 59.7203 14.5991 71.0195C14.5991 82.3191 23.0596 90.7226 34.2537 90.7226C45.4477 90.7224 53.9067 82.1824 53.9067 71.0195Z",
    fill: "url(#paint0_radial_104_1723)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4231 57.6086V41.4519L46.8779 30.1816V46.3383L83.4231 57.6086Z",
    fill: "url(#paint1_radial_104_1723)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4231 34.7265V18.5699L46.8779 7.29956V23.4562L83.4231 34.7265Z",
    fill: "url(#paint2_radial_104_1723)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_104_1723",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-68.824 83.4231 -68.824 -83.4231 83.4231 7.29956)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7012B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B80853"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_104_1723",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-68.824 83.4231 -68.824 -83.4231 83.4231 7.29956)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7012B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B80853"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_104_1723",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-68.824 83.4231 -68.824 -83.4231 83.4231 7.29956)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7012B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B80853"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKionMusicIconGradient);
export default __webpack_public_path__ + "static/media/kion_music_icon_gradient.5132f06d7714aa5eb0f3fcaa939ae717.svg";
export { ForwardRef as ReactComponent };